import reportesService from "../../services/reportes";

import moment from "moment";
export default {
  namespaced: true,
  state: {
    // state de movimientos
    reversiones: [],

    //  filter fechas inicio y fin
    fechaInicio: moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD"),
    fechaFin: moment().format("YYYY-MM-DD"),

    //  numero de pagina y total de registros
    page: 1,
    total: 0,
    visible: 7,

    // numero de registro por pagina
    rowsPerPage: 50,

    //loading en peticiones
    loading: false,

    //errores de api
    errored: false,
    error: false,

  },

  mutations: {
    // mutations movimientos
    setReversiones(state, reversiones) {
      state.reversiones = reversiones;
    },

    setPaginate(state, value) {
      state.page = value;
    },

    setTotal(state, value) {
      state.total = value;
    },
    setrowsPerPage(state, value) {
      state.rowsPerPage = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setErrord(state, value) {
      state.errored = value;
    },

    setFechaInicio(state, value) {
      state.fechaInicio = value;
    },

    setFechaFin(state, value) {
      state.fechaFin = value;
    },

  },

    actions: {
    async setFechaInicio({ commit }, fecha) {
        commit("setFechaInicio", fecha);
    },
    async setFechaFin({ commit }, fecha) {
        commit("setFechaFin", fecha);
    },
      
     async getReversiones({ commit, rootState, state }) {
        const params = {
            FechaInicio: moment(state.fechaInicio).format("DD-MM-YYYY"),
            FechaFin: moment(state.fechaFin).format("DD-MM-YYYY"),
            ClienteId: rootState.cliente_ID,
            CuentaId: rootState.cuenta_ID,
        };

         commit("setErrord", false);
         commit("setLoading", true);
         reportesService.reporteReversiones(params)
        .then((response) => {
          
          if (response?.data?.DetallesReversiones == null) {
            commit("setReversiones", []);
            commit("setPaginate", 1);
            commit("setTotal", 0);
            commit("setLoading", false);
          } else {
            // si la consulta es distinto de null se actualiza el store mutations movimientos
            commit("setReversiones", response?.data?.DetallesReversiones);
            commit("setPaginate", response.data.meta.page.currentPage);
            commit("setTotal", response.data.meta.page.lastPage);
            }
             this.$toast.error('Error de conexión. Intenta nuevamente.');
        })
        .catch((error) => {
          if (error.response) {
            var data = error.response.status;
          } else {
            commit("setErrord", true);
          }
        })
        .finally(() => commit("setLoading", false));
    },

  }, // Fin de actions

  getters: {
    fechaInicio: (state) => state.fechaInicio,
    fechaFin: (state) => state.fechaFin,
    pages: (state) => state.page,
    total: (state) => state.total,
    rowsPerPage: (state) => state.rowsPerPage,
    loading: (state) => state.loading,
    errored: (state) => state.errored,
    error: (state) => state.error,
    reversiones: (state) => state.reversiones,
  },

  modules: {},
};
